import { useState } from 'react';
import toast from 'react-hot-toast';

/**
 * useExport — wraps any exportAPI call and triggers a browser download.
 *
 * Usage:
 *   const { download, loading } = useExport();
 *   <button onClick={() => download(exportAPI.assetsPDF, 'assets.pdf')} disabled={loading}>
 *     Export PDF
 *   </button>
 */
export function useExport() {
  const [loading, setLoading] = useState(false);

  const download = async (apiFn, filename) => {
    setLoading(true);
    try {
      const response = await apiFn();
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href     = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success(`${filename} downloaded`);
    } catch {
      toast.error('Export failed — try again');
    } finally {
      setLoading(false);
    }
  };

  return { download, loading };
}
